import React from 'react'
import './list.css'
const List = () => {
  return (
    <div className='List'>
      <div className="ListSection">
        <div className="ListSectionColumn1">
          <img src="https://www.pixel-industry.com/html/musician/musician-html/img/pics/music-album-artist.jpg" alt="" />
          <div>
            <span><a href="">STORE</a>|</span>
            <span><a href="">ITUNES</a>|</span>
            <span><a href="">LISTEN</a></span>
          </div>
        </div>
        <div className="ListSectionColumn2">
          <div className="ListSectionColumn2Date">RELEASED MAR 23, 2016</div>
          <div className="ListSectionColumn2Heading"><a href="">Live from London</a> </div>
          <div className="ListSectionColumn2Items">
            <span>1. Rock It</span>
            <span>2. Faking Freedom</span>
            <span>3. Rock Will Find A Way</span>
            <span>4. Did I Mention Democracy</span>
            <span>5. Hysterics Connection</span>
            <span>6. Waiting For Remorse</span>
            <span>7. Hotshot Space</span>
            <span>8. Jealous Of My Spotlight</span>
            <span>9. Friendly Patience</span>
            <span>10. When It Comes to Diversity</span>
          </div>

        </div>
      </div>
      <div className="ListSection">
        <div className="ListSectionColumn1">
          <img src="https://www.pixel-industry.com/html/musician/musician-html/img/pics/music-album-artist-cover-02.jpg" alt="" />
          <div>
            <span><a href="">STORE</a>|</span>
            <span><a href="">ITUNES</a>|</span>
            <span><a href="">LISTEN</a></span>
          </div>
        </div>
        <div className="ListSectionColumn2">
          <div className="ListSectionColumn2Date">RELEASED MAR 23, 2016</div>
          <div className="ListSectionColumn2Heading"><a href="">Live from New York</a> </div>
          <div className="ListSectionColumn2Items">
            <span> 1. Blue Whisper</span>
            <span> 2. Coming Back For My Madman</span>
            <span> 3. Secrets Of The Hunter</span>
            <span> 4. Supernatural Feast</span>
            <span> 5. Missing Day</span>
            <span> 6. Step Away From The Danger</span>
            <span> 7. The Other Side Of Confidence</span>
            <span> 8. Just Another Lightning</span>
            <span> 9. Twister Sandwich</span>
            <span> 10. Running Out Of Knowledge</span>
          </div>

        </div>
      </div>
      <div className="ListSection">
        <div className="ListSectionColumn1">
          <img src="https://www.pixel-industry.com/html/musician/musician-html/img/pics/music-album-artist-cover-03.jpg" alt="" />
          <div>
            <span><a href="">STORE</a>|</span>
            <span><a href="">ITUNES</a>|</span>
            <span><a href="">LISTEN</a></span>
          </div>
        </div>
        <div className="ListSectionColumn2">
          <div className="ListSectionColumn2Date">RELEASED MAR 23, 2016</div>
          <div className="ListSectionColumn2Heading"><a href="">Jazz City</a> </div>
          <div className="ListSectionColumn2Items">
            <span> 1. Big Time Perfectionism</span>
            <span> 2. What Is This Thing Called Courage</span>
            <span> 3. Antique Sun</span>
            <span> 4. Reckless Ruin</span>
            <span> 5. Greased Adventure</span>
            <span> 6. Hollywood Madman</span>
            <span> 7. Sense Unleashed</span>
            <span> 8. New York Spotlight</span>
            <span> 9. Kindness Can't Explain</span>
            <span> 10. Rocking Star</span>
          </div>

        </div>
      </div>
    </div>
  )
}

export default List
